import classNames from "classnames";
import i18next from "i18next";
import { useEffectWithoutCleanup, useState } from "Shared/haunted/CustomHooks";
import { html } from "lit-html";
import { iconButton } from "Components/iconButton";
import { CUG3_LOGIN_URL } from "Services/constants";

export const useShadowDOM = false;
export const name = "cug3-login-handler";

const loaderClassName = "dg-for-cug3-login-loader";
const RESTRICTED_STATUS = 403;
const CHILE_COMPRA_SUPPORT_EMAIL = "soporte.chilecompra@jetsmart.com";

export const Component = () => {
	const [isRestricted, setIsRestricted] = useState<boolean>(false);
	const [modalMessage, setModalMessage] = useState<string | null>(null);

	useEffectWithoutCleanup(() => {
		const loader = window.newRtLoader(`.${loaderClassName}`);
		if (loader) {
			loader.startLoader();
		}

		const params = new URLSearchParams(window.location.search);
		const session = params.get("session");
		const iv = params.get("iv");

		const formData = new FormData();
		formData.append("session", session);
		if (iv) {
			formData.append("iv", iv);
		}

		fetch(`${window.JetSmart.Settings.BookingUrl}/${CUG3_LOGIN_URL}`, {
			method: "POST",
			redirect: "follow",
			body: formData,
			credentials: "include",
		})
			.then(async (res) => {
				if (res.ok) {
					window.location.href = "/changeLanguage?newCountryCode=cl&newLanguageCode=es";
					return;
				}

				if (res.status === RESTRICTED_STATUS) {
					let reason: string | null = null;
					try {
						const problem = await res.json();
						reason = problem?.Detail ?? null;
					} catch {
						// non-JSON body
					}
					setIsRestricted(true);
					setModalMessage(reason);
				} else {
					setModalMessage(
						i18next.t("Ocurrió un error al iniciar sesión. Por favor, inténtalo nuevamente más tarde.")
					);
				}
			})
			.catch(() =>
				setModalMessage(
					i18next.t("Ocurrió un error al iniciar sesión. Por favor, inténtalo nuevamente más tarde.")
				)
			)
			.finally(() => {
				if (loader) {
					loader.stopLoader();
					loader.destroy();
				}
			});
	}, []);

	const homeButton = iconButton({
		isAction: true,
		icon: html`<i class="jsh-circle-chevron-right1 text-base"></i>`,
		label: i18next.t("Volver al inicio"),
		onClick: () => {
			window.location.href = "/";
		},
	});

	const messageContent = isRestricted
		? html`
				<p>
					${i18next.t("ChileCompraRestrictedMessage")}
					<a class="underline" href="mailto:${CHILE_COMPRA_SUPPORT_EMAIL}">${CHILE_COMPRA_SUPPORT_EMAIL}</a>
				</p>
				${modalMessage ? html`<p class="mt-2">${modalMessage}</p>` : ""}
			`
		: html`${modalMessage}`;

	const modalTemplate =
		isRestricted || modalMessage
			? html`
					<div class="fixed inset-0 z-[100001] bg-n-blue/75 backdrop-blur-xs">
						<div
							class="absolute !w-[550px] max-w-[95%] overflow-hidden rounded-2xl bg-white all-center"
							data-test-id="cug3-login-error-modal"
						>
							<div class="modal-body">
								<div class="flex w-full justify-center py-3">
									<i class="jsh-icon jsh-broken-circle-exclamation text-[100px] text-be-cyan-2"></i>
								</div>
								<div class="px-6 text-center font-body leading-snug text-be-blue-2">${messageContent}</div>
							</div>
							<div class="flex w-full justify-center p-6">${homeButton.htmlTemplate()}</div>
						</div>
					</div>
				`
			: "";

	return html`<div class=${classNames("min-h-svh", loaderClassName)}>${modalTemplate}</div>`;
};
